import { FeaturesPanel } from './FeaturesPanel';

export default FeaturesPanel;
